import { cn } from '@/lib/utils';
import React, { useImperativeHandle, useRef, useState } from 'react';

const ratingToValue = rating => {
  if (!rating || typeof rating !== 'number' || isNaN(rating)) return 0;

  const divided = rating / 20;

  return divided - Math.floor(divided) > 0 ? Math.floor(divided) + 0.5 : divided;
};

/** @type {(props:{rating:number;disabled?:boolean, classNames?: { root?: string; star?: string;}},ref:{value:number,setValue:import('react').Dispatch<import('react').SetStateAction<number>>}) => import('react').ReactNode} */
const Rating = React.forwardRef((props, ref) => {
  // rating 0 - 100

  const { rating, disabled, classNames = {} } = props;

  // 1 - 5
  const [value, setValue] = useState(() => ratingToValue(rating));

  const prevPropsRef = useRef({ rating });

  if (prevPropsRef.current.rating !== rating) {
    prevPropsRef.current.rating = rating;
    setValue(ratingToValue(rating));
  }

  useImperativeHandle(ref, () => ({
    value,
    setValue,
  }));

  return (
    <div className={cn('flex items-center gap-x-[3px]', classNames.root)}>
      {Array.from({ length: 5 }, (_, i) => {
        const hasLevelValue = value > i;
        const levelValue = hasLevelValue ? (value - i > 1 ? 1 : value - i) : 0;

        return (
          <div
            className={cn('w-[15px]', classNames.star)}
            key={i}
          >
            <div className='relative pb-[105%]'>
              <div className='absolute left-0 top-0 h-full w-full'>
                <div
                  className={cn(
                    ' relative h-full w-[15px]',
                    disabled ? 'cursor-default' : 'cursor-pointer',
                    classNames.star,
                  )}
                  onClick={() => {
                    if (disabled) return;

                    setValue(i + 1);
                  }}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='19'
                    fill='none'
                    viewBox='0 0 20 19'
                    className={cn('h-auto w-[15px]', classNames.star)}
                  >
                    <path
                      fill='#E7DED5'
                      d='m9.512 0 2.939 5.955 6.571.955-4.755 4.635 1.123 6.545L9.512 15l-5.878 3.09 1.122-6.545L.001 6.91l6.572-.955z'
                    ></path>
                  </svg>

                  <div
                    className={cn('absolute left-0 top-0 h-full w-full overflow-hidden', classNames.starFill)}
                    style={{ width: `${(levelValue / 1) * 100}%` }}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='20'
                      height='19'
                      fill='none'
                      viewBox='0 0 20 19'
                      className={cn('absolute left-0 top-0 h-auto w-[15px]', classNames.star)}
                    >
                      <path
                        fill='#B67349'
                        d='m9.512 0 2.939 5.955 6.571.955-4.755 4.635 1.123 6.545L9.512 15l-5.878 3.09 1.122-6.545L.001 6.91l6.572-.955z'
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
});

export default Rating;
